const componentsRegistry = new Map();

export function registerComponent(tagName, ctor, source) {
    const entry = componentsRegistry.get(tagName) ?? {};
    if (source === 'custom') {
        entry.custom = ctor;
    } else {
        entry.base = ctor;
    }
    componentsRegistry.set(tagName, entry);
}

export function registerAllComponents() {
    for (const [tagName, { custom, base }] of componentsRegistry.entries()) {
        const ctor = custom ?? base;
        if (!ctor) continue;
        if (!customElements.get(tagName)) {
            customElements.define(tagName, ctor);
        }
    }
}
